<template>
  <div class="home">
    <div class="home-left">
      <!-- 校历 -->
      <div class="school-calendar">
        <div class="calendar-head">
          <h6 class="common-title">校历</h6>
          <span>{{ SchoolCalendar.semester }}</span>
        </div>
        <div class="calendar-main">
          <span v-show="SchoolCalendar.week">第{{ toChinesNum(+SchoolCalendar.week) }}周</span>
        </div>
        <div class="img-bg" />
      </div>
      <!-- 个人基础信息 -->
      <div class="user-info b-mgt">
        <div class="horizontal">
          <div class="avatar">
            <ming-image :src="userInfo.headimg || userInfo.headimgUrl" width="120px" height="168px" type="user" />
          </div>
          <div class="info">
            <div class="info-item">
              <label>姓名:</label>
              <span>{{ userInfo.name }}</span>
            </div>
            <div class="info-item">
              <label>班级:</label>
              <span>{{ userInfo.className || '-' }}</span>
            </div>
            <div class="info-item">
              <label>学号:</label>
              <span>{{ userInfo.idnumber }}</span>
            </div>
            <div class="info-item">
              <label>手机:</label>
              <span>{{ userInfo.blurMobile }}</span>
            </div>
            <div class="info-item">
              <label>邮箱:</label>
              <span>{{ userInfo.blurEmail }}</span>
            </div>
          </div>
        </div>
        <ul class="quick-entry">
          <li v-for="item in quickEntryList" :key="item.id" @click="routerPushName(item.name)">
            {{ item.title }}
          </li>
        </ul>
      </div>
      <!-- 活动预约 -->
      <div class="active-order b-mgt">
        <div class="active-head">
          <h6 class="common-title">活动预约</h6>
          <el-link title="更多活动预约" @click="routeActivityMore"> 更多&gt; </el-link>
        </div>
        <div v-show="activityList && activityList.length > 0" class="order-list">
          <div v-for="item in activityList" :key="item.id" class="list-item" :class="{ disabled: item.expired }">
            <div class="item-content" @click="routerActivityItem(item.id)">
              <h3 :title="item.title">
                {{ item.title }}
              </h3>
              <div class="info">
                <span><i class="el-icon-time" />&nbsp;&nbsp;活动时间：{{ item.startTime }} ~ {{ item.endTime }}</span>
                <!-- <el-divider direction="vertical" /> -->
                <span v-if="+item.isOnline === 0" class="address ellipsis" :title="item.address"><i class="el-icon-location-outline" /> {{ item.address }}</span>
                <span v-else class="address"><i class="el-icon-location-outline" /> 线上</span>
              </div>
            </div>
            <div v-if="item.isApply == 1">
              <template v-if="item.expired">
                <div class="link-btn disabled">活动已结束</div>
              </template>
              <template v-else>
                <div v-if="item.userApply === 0" class="link-btn" @click="activetySign(item.id)">取消参与</div>
                <div v-if="item.userApply === -2" class="link-btn">报名失败</div>
                <div v-if="item.userApply === 1" class="link-btn">报名成功</div>
                <div v-if="item.userApply === -1" class="link-btn" style="background-color: var(--theme-color); color: #fff" @click="activetySign(item.id, item.userApply)">
                  参与报名
                </div>
                <!-- <div v-if="item.userApply" class="link-btn" @click="activetySign(item.id, item.userApply)">{{ item.userApplyType === 1 ? '取消参与' : '取消旁听' }}</div>
                <div v-else class="link-btn" style="background-color: var(--theme-color); color: #fff;" @click="activetySign(item.id, item.userApply)">参与报名</div> -->
              </template>
            </div>
            <div v-else class="link-btn disabled">无需报名</div>
          </div>
        </div>
        <empty-component v-if="!activityList?.length" text="暂无相关信息"></empty-component>
      </div>

      <!-- 最新文档 -->
      <div class="latest-documents b-mgt">
        <div class="document-head">
          <h6 class="common-title">最新文档</h6>
          <el-button type="text" @click="routerPushName('DocsIndex')"> 更多&gt; </el-button>
        </div>
        <ul class="document-list">
          <li v-for="item in DocsList" :key="item.id">
            <p class="ellipsis">
              <a :href="item.path" target="_blank" :title="item.title" :download="item.title">{{ item.title }}</a>
            </p>
            <a class="link-btn" target="_blank" :title="item.title" :href="item.path" :download="item.title">下载</a>
          </li>
        </ul>
        <div v-show="DocsList.length === 0" class="my-empty">暂无文档</div>
      </div>
    </div>
    <div class="home-right">
      <!-- 课程日历 -->
      <div class="course-calendar">
        <div class="course-head">
          <h6 class="common-title">课程日历</h6>
          <el-button type="text" @click="routerPushName('MyCourse')"> 更多&gt; </el-button>
        </div>
        <div class="course-main">
          <ming-date-pick v-loading="calendarLoading" style="width: 271px; height: 302px" :includes="calendarDates" @complated="selectDate" @monthChange="monthChange" />
          <div class="line" />
          <div class="course-content">
            <span class="tlt">{{ courseDate }}课程列表</span>
            <ul v-show="courseList.length > 0">
              <li v-for="(item, index) in courseList" :key="item.startTime + index">
                <span>{{ item.startTime }}-{{ item.endTime }}</span>
                <span class="courseName">{{ item.courseName }}</span>
              </li>
            </ul>
            <div v-show="courseList.length === 0" class="empty">
              <!-- eslint-disable-next-line -->
              <img src="@/assets/empty.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- 我的事务 -->
      <div v-if="false" class="my-business b-mgt">
        <div class="business-head">
          <h6 class="common-title">我的事务</h6>
          <el-button type="text"> 更多&gt; </el-button>
        </div>
        <ul class="business-list">
          <li v-for="item in 4" :key="item">
            <p class="before-class ellipsis">M2093/94/95/96/97/98/9A/9B/9C/9F班及延期同学12或1月答辩批次班及延期同学9F班及延期同学12或1月答辩批次班及延期同学</p>
            <span>2022/06/28</span>
          </li>
        </ul>
      </div>

      <!-- 新闻资讯 -->
      <div class="news b-mgt">
        <div class="news-head">
          <h6 class="common-title">新闻资讯</h6>
          <el-link v-show="newsListData?.pageurl" :href="newsListData.pageurl" title="更多新闻资讯" target="_blank"> 更多&gt; </el-link>
        </div>
        <div v-show="newsListData?.list && newsListData?.list?.length > 0" class="news-list">
          <a v-for="item in newsListData.list" :key="item.createtime" :href="item.weburl" :title="item.title" target="_blank">
            <div class="news-item">
              <ming-image :src="item.thumb" width="180px" height="93px" fit="cover" style="border-radius: 3px; overflow: hidden; flex-shrink: 0" />
              <div class="news-content" style="margin-left: 1em">
                <h5 class="ellipsis">{{ item.title }}</h5>
                <p class="ellipsis_two">{{ item.description }}</p>
              </div>
            </div>
          </a>
        </div>
      </div>
      <!-- 通知公告 -->
      <div class="my-business b-mgt" v-loading="noticeLoading">
        <div class="business-head">
          <h6 class="common-title">通知公告</h6>
          <el-button type="text" @click="routerPushName('Notice')"> 更多&gt; </el-button>
        </div>
        <!-- {{ noticeListData?.lists }} -->
        <ul class="notice-list" style="padding: 0 16px">
          <li v-for="(item, index) in noticeListData?.lists" :key="index" @click="goNoticeDetail(item)">
            <div>
              <p>{{ item.title }}</p>
              <small>{{ timeFormat(item.ctime * 1000) }} </small>
            </div>
            <span>查看</span>
          </li>
        </ul>
        <empty-component v-if="!noticeListData?.lists?.length" text="暂无相关信息"></empty-component>
      </div>
    </div>
    <el-dialog
      title="课程评估提醒"
      :visible.sync="assessimentTipsDialog"
      width="1000px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="closeTipsDialog"
    >
      <ming-table v-model="assessismentData" :fields="assessismentColumn">
        <template #myAssessmentState="{ scope }">
          {{ scope.myAssessmentState ? '已评估' : '未评估' }}
        </template>
        <template #options="{ scope }">
          <el-button type="text" @click="toAssessment(scope.id)"> 立即评估 </el-button>
        </template>
      </ming-table>
    </el-dialog>
  </div>
</template>

<script setup>
import MingDatePick from '@/components/MingDatePick'
import MingImage from '@/components/MingImage'
import { ref, computed, onMounted } from 'vue'
import moment from '@/utils/moment'
import { Message, MessageBox, Loading } from 'element-ui'
import Router from '@/router'
import Store from '@/store'
import { toChinesNum } from '@/utils'
import API from '@/api'
import EmptyComponent from '@/components/EmptyComponent.vue'
import { timeFormat } from '@/utils'
const userInfo = computed(() => {
  return Store.state.user.userInfo
})

function routerPushName(name) {
  if (!name) {
    Message.info('敬请期待')
  } else {
    Router.push({
      name
    })
  }
}

const entryArr = ref([
  {
    id: 1,
    title: '我的课表',
    name: 'MySchedule'
  },

  {
    id: 3,
    title: '常用文档',
    name: 'DocsIndex'
  }
])

const userType = computed(() => Store.getters.userInfo.dean_type || 'mba')
const quickEntryList = computed(() => {
  const arr = entryArr.value
  if (userType.value === 'mba') {
    arr.push({
      id: 2,
      title: '培养计划',
      name: 'TrainingPlan'
    })
  }
  return arr
})

const courseDate = ref(moment(new Date()).format('YYYY年MM月DD日'))
const courseList = ref([])
const selectDate = val => {
  courseDate.value = val.formatDate
  courseList.value = calendarCourses.value.filter(item => {
    if (item.date === val.fullDate) {
      return item
    }
  })
}

// function formatDate(date) {
//   if (!date) return ''
//   // const val = +date * 1000
//   return moment(date).format('YYYY-MM-DD')
// }

/* 切换月数 */
const monthChange = val => {
  // console.log('val', val)
  CourseCalendar(val)
}

/* 校历 */
const SchoolCalendar = ref({
  semester: '',
  week: 0
})

function getSchoolCalendar() {
  API.Semester().then(res => {
    if (+res.code === 200) {
      SchoolCalendar.value = res.data
    }
  })
}

const calendarDates = ref([])
const calendarCourses = ref([])
const calendarLoading = ref(false)
/* 获取日历数据 */
function CourseCalendar(date) {
  const yearMonth = date || moment(new Date()).format('YYYY-MM')
  const formData = new FormData()
  formData.append('yearMonth', yearMonth)

  const dean_type = userInfo.value.dean_type.toUpperCase()
  calendarLoading.value = true
  API[`${dean_type}CourseCalendar`](formData)
    .then(res => {
      if (+res.code === 200) {
        if (res.data === null || !res.data) return
        const { dates, courses } = res.data
        calendarDates.value = dates
        calendarCourses.value = courses
      }
      calendarLoading.value = false
    })
    .catch(_ => {
      calendarLoading.value = false
    })
}

/* 最新文档 */
const DocsList = ref([])

function getDocsList() {
  API.HomeDocsList({
    pageSize: 5
  }).then(res => {
    if (+res.code === 200) {
      DocsList.value = res.data
    }
  })
}

/* 活动 */
const activityList = ref({})

function getActivityList() {
  API.getActivityLists({
    page: 1,
    pageSize: 5
  }).then(res => {
    if (+res.code === 200) {
      activityList.value = res.data.lists
    }
  })
}
// 报名 or 取消参与
function activetySign(actid, state) {
  if (!actid) return
  if (state === -1) {
    const loading = Loading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.3)'
    })
    API.actSignUp({
      id: actid
    }).then(res => {
      loading.close()
      if (+res.code === 200) {
        Message.success(res.msg)
        getActivityList()
      } else {
        Message.error(res.msg)
      }
    })
  } else {
    MessageBox.confirm(`您确定要取消参与该活动吗？`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        API.cancelActSignUp({
          id: actid
        }).then(res => {
          if (+res.code === 200) {
            Message.success(res.msg)
            getActivityList()
          }
        })
      })
      .catch(() => {
        console.log('取消')
      })
  }
}

function routeActivityMore() {
  Router.push({
    name: 'ActivityList'
  })
}

function routerActivityItem(id) {
  Router.push({
    name: 'ActivityDetail',
    params: {
      id
    }
  })
}

// 获取新闻列表
const newsListData = ref({})

function getNewsLists() {
  API.getNewsLists({
    page: 1,
    pagesize: 5
  }).then(res => {
    if (+res.state === 200) {
      newsListData.value = res.data
    }
  })
}

// 获取新闻列表
const noticeListData = ref({})
const noticeLoading = ref(false)
function getNoticesLists() {
  noticeLoading.value = true
  API.getNoticesLists({
    page: 1,
    pageSize: 5
  }).then(res => {
    if (+res.code === 200) {
      noticeListData.value = res.data
    }
    noticeLoading.value = false
  })
}

// 获取强制课程评估的数据
const assessimentTipsDialog = ref(false)
const assessismentData = ref([])
const assessismentColumn = ref([
  {
    label: '课程名称',
    field: 'courseName'
  },
  {
    label: '授课老师',
    field: 'teacher'
  },
  {
    label: '课程评估情况',
    field: 'myAssessmentState',
    slot: true
  },
  {
    label: '操作',
    field: 'options',
    slot: true
  }
])

function closeTipsDialog() {
  assessimentTipsDialog.value = false
}

function GetAssessmentTips() {
  API.AssessmentTips().then(res => {
    if (+res.code === 200) {
      if (res.data && res.data.length > 0) {
        assessismentData.value = res.data
        assessimentTipsDialog.value = true
      } else {
        assessimentTipsDialog.value = false
      }
    }
  })
}

function toAssessment(id) {
  Router.push({
    name: 'forceAssessment',
    params: {
      id
    }
  })
}

function goNoticeDetail(item) {
  Router.push({
    name: 'NoticeDetail',
    params: {
      id: item.id
    }
  })
}

onMounted(() => {
  Promise.allSettled([getDocsList(), getSchoolCalendar(), CourseCalendar(), getActivityList(), getNewsLists(), GetAssessmentTips(), getNoticesLists()])
})
</script>

<style lang="scss" scoped>
@mixin commonPlate {
  padding: 20px 0;
  background-color: var(--plate-background-color);
  border-radius: 8px;
}

@mixin commonTtleBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 16px;
}

.line {
  width: 1px;
  height: 302px;
  background-color: #ccc;
  margin: 0 60px;
  transition: all linear 0.3s;
}

.home {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .home-left {
    width: 568px;
    transition: all linear 0.3s;
  }

  .home-right {
    width: 852px;
    transition: all linear 0.3s;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1440px) {
  .line {
    margin: 0 30px;
  }

  .home {
    .home-left {
      width: 473px;
    }

    .home-right {
      width: 710px;
    }
  }
}

/* 用户信息 */
.user-info {
  @include commonPlate();
  padding: 16px;

  .horizontal {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .avatar {
    // width: 120px;
    // height: 168px;
    // background-color: #EAEAEA;
    display: flex;
    justify-content: center;
    align-items: center;
    // padding: 10px;
    box-sizing: border-box;
  }

  .info {
    height: 168px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 20px;

    .info-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      label {
        display: inline-block;
        width: 60px;
        font-size: var(--title-font-size);
        color: #666;
        font-weight: 500;
      }

      span {
        font-size: var(--title-font-size);
        color: #333;
      }
    }
  }

  .quick-entry {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;

    li {
      list-style: none;
      width: 80px;
      height: 40px;
      line-height: 38px;
      border: 1px solid var(--theme-color);
      border-radius: 6px;
      box-sizing: border-box;
      background: #fdfdfd;
      text-align: center;
      font-size: var(--title-font-size);
      color: var(--theme-color);
      cursor: pointer;
      transition: all linear 0s;
      margin-top: 20px;

      &:not(:last-child) {
        margin-right: 10px;
      }

      &:hover {
        background-color: var(--theme-color);
        color: #fff;
        transition: all linear 0.3s;
      }
    }
  }
}

/* 校历 */
.school-calendar {
  position: relative;
  padding: 20px 0;
  box-sizing: border-box;
  background-color: var(--plate-background-color);
  border-radius: 8px;
  height: 121px;

  .calendar-head {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    span {
      margin-left: 24px;
      font-size: var(--title-font-size);
      color: #777;
    }
  }

  .calendar-main {
    padding-left: 76px;
    font-weight: 600;
    font-size: 28px;
    color: #333;
    margin-top: 30px;
  }

  .img-bg {
    position: absolute;
    bottom: 0;
    right: 118px;
    width: 85px;
    height: 110px;
    background-image: url('@/assets/calendar-bg.png');
    box-sizing: 100% 100%;
  }
}

/* 最新文档 */
.latest-documents {
  @include commonPlate();

  .document-head {
    @include commonTtleBox();
  }

  .document-list {
    margin: 0;
    padding: 0 16px;

    li {
      list-style: none;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 30px;

      a {
        font-size: var(--title-font-size);
      }

      p {
        margin: 0;
      }
    }
  }
}

/* 活动预约 */
.active-order {
  @include commonPlate();

  .active-head {
    @include commonTtleBox();
  }

  .order-list {
    margin-top: 30px;

    .list-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 16px;

      &.disabled {
        .item-content {
          filter: opacity(0.6);
        }

        .is-disabled {
          border-color: #bbbbbb;
        }
      }

      .item-content {
        cursor: pointer;
        width: 419px;

        erData h3 {
          font-weight: 400;
          font-size: 16px;
        }

        p {
          margin: 0;
          font-size: var(--title-font-size);
          color: #333;
        }

        .info {
          // display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-top: 10px;
          font-size: var(--content-font-size);
          color: #888888;

          .address {
            display: block;
            width: 200px;
          }
        }
      }

      .el-button {
        min-width: 90px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: none !important;
        font-size: 16px;
      }

      &:not(:last-child) {
        margin-bottom: 50px;
      }

      &:hover {
        .item-content {
          p {
            color: var(--theme-color);
          }
        }
      }
    }
  }
}

/* 课程日历 */
.course-calendar {
  @include commonPlate();
  height: 402px;

  .course-head {
    @include commonTtleBox();
  }

  .course-main {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 25px;

    .empty {
      width: 140px;
      height: 140px;
      margin: 0 auto;
      margin-top: 50px;
    }

    .course-content {
      width: 320px;

      span.tlt {
        display: block;
        text-align: center;
        font-size: 18px;
        font-weight: 500;
      }

      ul {
        height: 250px;
        overflow-y: auto;
        padding: 0;
        scroll-behavior: smooth;

        &::-webkit-scrollbar {
          width: 4px;
          transition: width linear 0.3s;
        }

        &:hover::-webkit-scrollbar {
          width: 6px;
          transition: width linear 0.3s;
        }

        &::-webkit-scrollbar-thumb {
          background-color: var(--theme-color);
          border-radius: 6px;
        }

        li {
          list-style: none;
          display: flex;
          align-items: flex-start;
          font-size: 16px;
          color: #333;

          span.courseName {
            display: block;
            width: 170px;
          }

          span:not(:last-child) {
            margin-right: 20px;
          }

          &:not(:last-child) {
            margin-bottom: 30px;
          }

          &::before {
            content: '';
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: var(--theme-color);
            margin-right: 10px;
            margin-top: 6px;
          }
        }
      }
    }
  }
}

/* 我的事务 */
.my-business {
  @include commonPlate();

  .business-head {
    @include commonTtleBox();
  }

  .business-list {
    padding: 0;
    margin: 0;
    margin-top: 20px;

    li {
      width: 100%;
      list-style: none;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 16px;
      box-sizing: border-box;

      p {
        position: relative;
        margin: 0;
        cursor: pointer;
        padding-right: 10px;
        font-size: 16px;

        &.before-class {
          padding-left: 10px;

          &::before {
            position: absolute;
            top: 50%;
            left: 0;
            margin-top: -3px;
            content: '';
            display: inline-block;
            width: 6px;
            height: 6px;
            background-color: var(--theme-color);
            border-radius: 50%;
            margin-right: 10px;
          }
        }
      }

      span {
        color: #777777;
        font-size: 16px;
      }

      &:not(:first-child) {
        margin-top: 24px;
      }

      &:hover {
        p {
          color: var(--theme-color);
        }
      }
    }
  }
}

.news {
  @include commonPlate();

  .news-head {
    @include commonTtleBox();
  }

  .news-list {
    margin-top: 30px;

    a {
      display: block;

      &:not(:last-child) {
        margin-bottom: 31px;
      }
    }

    .news-item {
      display: flex;
      justify-content: space-between;
      padding: 0 16px;
      cursor: pointer;

      img {
        display: block;
        width: 130px;
        height: 74px;
      }

      .news-content {
        width: calc(100% - 195px);
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        h5,
        p {
          margin: 0;
          padding: 0;
        }

        h5 {
          font-size: 1.17em;
          font-weight: 400;
        }

        p {
          font-size: var(--content-font-size);
          color: #777;
        }
      }

      &:hover {
        .news-content {
          h5 {
            color: var(--theme-color);
          }
        }
      }
    }
  }
}
</style>
